
export const SET_PROPERTY = 'SET_PROPERTY';
export const SET_NEW_TESTIMONIO = 'SET_NEW_TESTIMONIO';
export const SET_TESTIMONIOS = 'SET_TESTIMONIOS';
export const SET_TESTIMONIO = 'SET_TESTIMONIO';
export const SET_FORM = "SET_FORM"
export const SET_FORM_PROPERTY = 'SET_FORM_PROPERTY';
export const UPDATE_FORM = 'UPDATE_FORM';